import { useMutation, useQueryClient } from '@tanstack/react-query';
import { massDestroyProjects } from '../../api/apiProjects';
import toast from 'react-hot-toast';

export const useMassDestroyProjects = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: massDestroyProjects,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['projects'] });
            toast.success(data.message || 'Projects deleted successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to delete projects';
            toast.error(errorMessage);
        },
    });
};